import prepareRecordForPosting from './prepareRecordForPosting';

const runBody = ({ trains, wells, aggregates, config }) => ({
  trains: trains.items.map(prepareRecordForPosting),
  wells: wells.items.map(prepareRecordForPosting),
  aggregates: prepareRecordForPosting(aggregates),
  config
});

export default runBody;